import React from 'react'
import { createUseStyles } from 'react-jss'
import { colors } from '../../../theme/palette'

const useStyles = createUseStyles(() => ({
    row: {
        backgroundColor: colors.white,
        width: '100%',
        color: 'black',
        display: 'flex',
        flexDirection: 'column',
    },
}))

const CardContentMobile: React.FC = ({ children }) => {
    const classes = useStyles()

    return <div className={classes.row}>{children}</div>
}

export { CardContentMobile }
